import PropTypes from "prop-types";
import React from "react";
import {NavigationItems} from "../../config/config";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons";
import {Link, useLocation} from "react-router-dom";

const isSelectedMenu = (path, id) => {
	if (
		(path === '/' && id === 'home')
		|| (path === 'forums' && id === 'forum')
		|| (path === 'gai-goi-ha-noi' && id === 'category-hanoi')
		|| (path === 'gai-goi-sai-gon' && id === 'category-saigon')
		|| (path === 'gai-goi-thanh-pho-khac' && id === 'category-other')
		|| (path === 'videos' && id === 'video')
	) {
		return true;
	} else {
		return false;
	}
}

const CanvasMenu = ({ isOpen, toggleMenu }) => {
	const location = useLocation();

	return (
		<div className={`fixed top-0 left-0 h-full w-full bg-[#142734] text-[#dedede] transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out`}>

			<div className="p-4 flex justify-between items-center text-white">
				<p>Menu</p>

				<FontAwesomeIcon icon={faTimes} onClick={toggleMenu} />
			</div>

			<ul className="mt-4 text-white">
				{NavigationItems.map((item, i) => (
					<Link key={i}
					      className={`block p-4 border-b border-url border-opacity-10 hover:underline 
					                    ${isSelectedMenu(location.pathname, item.id) ? 'is-selected font-bold text-url bg-gray-700' : ''}
					                 `}
					      to={item.url}
					      onClick={toggleMenu}>
						{item.title}
					</Link>
				))}
			</ul>
		</div>
	);
}

CanvasMenu.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	toggleMenu: PropTypes.func.isRequired,
};

export default CanvasMenu;